import React from "react";
import { endSession } from "../../redux/api";
import "./SessionGate.css";

/*
 * What a signed-in page shows while the server is asked who is signed in and
 * there is no saved copy to show meanwhile. Drawing the page anyway was the
 * blank sidebar: a menu built from nothing.
 */
export default function SessionGate({ status, onRetry }) {
  const failed = status === "failed";

  return (
    <div
      className="session-gate"
      role={failed ? "alert" : "status"}
      aria-live="polite"
    >
      {failed ? (
        <>
          <p className="session-gate__title">We couldn't load your account.</p>
          <p className="session-gate__text">
            Check the connection and try again.
          </p>
          <div className="session-gate__actions">
            <button type="button" className="btn btn-primary" onClick={onRetry}>
              Try again
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={endSession}
            >
              Sign out
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="spinner-border text-secondary" aria-hidden="true" />
          <p className="session-gate__text">Loading your account…</p>
        </>
      )}
    </div>
  );
}
